var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.654,
    height: 39.375,
    viewBox: "0 0 46.654 39.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    width: 39.654,
    height: 32.375,
    rx: 4,
    fill: "none",
    stroke: "#b6b6b6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_77_126",
    "data-name": "Component 77 \\u2013 126",
    transform: "translate(0.501 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_816",
    "data-name": "Rectangle 816",
    width: 45.654,
    height: 38.375,
    rx: 4,
    fill: "none",
    stroke: "#b6b6b6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_47",
    "data-name": "Mask Group 47",
    transform: "translate(3 3)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5916",
    "data-name": "Group 5916",
    transform: "translate(58.898 41.748) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(4.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5915",
    "data-name": "Group 5915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M4.691,0A4.663,4.663,0,0,0,1.017,1.809c.206.088.41.154.62.253l-.559,1.2c-.253-.118-.492-.2-.736-.3A4.631,4.631,0,0,0,2.667,8.9l.376-1.406A3.264,3.264,0,0,1,1.379,4.687,3.309,3.309,0,1,1,4.688,8a3.209,3.209,0,0,1-.4-.081L3.924,9.3a4.589,4.589,0,0,0,.765.078A4.668,4.668,0,0,0,8.111,7.869L7.823,7.66l.715-1.115.324.232A4.656,4.656,0,0,0,4.691,0Z",
    transform: "translate(31.843 16.031)",
    fill: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    d: "M74.933,26.624l-.625-1.164,1.16-.63.142.268L79.677,5.453c-11.157,6.01-17.257,9.118-32.573,0-11.41-6.8-18.268-7.727-36.867,0L6.242,24.745l1.082-.436.49,1.229L6.59,26.03l-.4-1L0,54.9c12.84-6.981,19.911-7.511,28.125-6.053,0,0,.152-.092,1.837.726s3.347,2.807,6.905,5.326c14.549,10.3,21.416,6.01,32.571,0l5.9-28.491Zm-64.6-2.107-.5-1.224,2.509-1.018.5,1.224Zm5.019-2.033-.5-1.224q1.335-.54,2.523-1.009l.483,1.231Zm5.021-1.972-.462-1.233c.923-.35,1.778-.649,2.571-.921l.417,1.255q-1.161.383-2.526.9Zm5.078-1.662-.324-1.295a17.4,17.4,0,0,1,2.763-.495l.121,1.316a16.8,16.8,0,0,0-2.559.476ZM40.425,2.771l1.276.341L41.02,5.666l-1.274-.339ZM39.067,7.879l1.276.339-.684,2.554-1.276-.339ZM30.109,46.547l-1.271-.338.679-2.559,1.276.341Zm1.364-5.108L30.2,41.1l.684-2.554,1.276.341Zm1.361-5.106-1.276-.341.682-2.554,1.276.341ZM34.2,31.226l-1.276-.341.684-2.554,1.276.324Zm7.608-5.977-.784-.566a5.977,5.977,0,0,1-10.1-6.072c-.135-.033-.272-.08-.407-.106l.237-1.295c.256.045.514.128.774.2a5.606,5.606,0,0,1,5.686-2.616L37.691,13l1.276.338L38.5,15.08a5.926,5.926,0,0,1,3.276,8.515l.8.573Zm4.555,3.03q-1.129-.671-2.32-1.47l.741-1.1q1.165.774,2.268,1.43Zm4.931,2.471c-.824-.324-1.671-.71-2.523-1.141l.6-1.177c.817.41,1.619.779,2.41,1.087Zm5.381,1.42a20.092,20.092,0,0,1-2.746-.54l.348-1.276a18.707,18.707,0,0,0,2.557.5Zm2.8.13-.038-1.321a16.979,16.979,0,0,0,2.59-.284l.244,1.295a18.443,18.443,0,0,1-2.791.31Zm5.506-.994-.4-1.26c.788-.253,1.619-.554,2.483-.925l.511,1.217c-.923.372-1.771.691-2.6.952ZM70.066,29.2l-.582-1.188c.784-.381,1.581-.793,2.393-1.219l.618,1.167q-1.243.639-2.433,1.229Z",
    fill: "#9c9c9c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4188",
    "data-name": "Path 4188",
    d: "M25.186.078c17.092-.967,6.644,7.227,6.644,16.834S27,34.894,17.4,34.894A17.4,17.4,0,0,1,0,17.5C0,7.893,8.093,1.045,25.186.078Z",
    transform: "translate(0 23.571)",
    fill: "#7b7b7b",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4189",
    "data-name": "Path 4189",
    d: "M9.805.078C-7.287-.889,3.162,7.305,3.162,16.912S7.988,34.894,17.6,34.894A17.4,17.4,0,0,0,34.99,17.5C34.99,7.893,26.9,1.045,9.805.078Z",
    transform: "translate(47.112 9.8)",
    fill: "#7b7b7b",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4190",
    "data-name": "Path 4190",
    d: "M21.348.066c14.488-.82,5.631,6.126,5.631,14.269S22.888,29.578,14.745,29.578A14.745,14.745,0,0,1,0,14.833C0,6.69,6.86.885,21.348.066Z",
    transform: "translate(2.666 26.23)",
    fill: "#7b7b7b",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4191",
    "data-name": "Path 4191",
    d: "M8.311.066C-6.177-.754,2.68,6.192,2.68,14.335S6.771,29.578,14.914,29.578A14.745,14.745,0,0,0,29.659,14.833C29.659,6.69,22.8.885,8.311.066Z",
    transform: "translate(49.778 12.459)",
    fill: "#7b7b7b",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4192",
    "data-name": "Path 4192",
    d: "M17.88.056c12.135-.7,4.717,5.229,4.717,12.18S19.17,25.247,12.35,25.247A12.469,12.469,0,0,1,0,12.661C0,5.71,5.746.756,17.88.056Z",
    transform: "translate(2.666 30.561)",
    fill: "#7b7b7b",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4193",
    "data-name": "Path 4193",
    d: "M6.961.056c-12.134-.7-4.716,5.229-4.716,12.18S5.671,25.247,12.492,25.247A12.469,12.469,0,0,0,24.841,12.661C24.841,5.71,19.1.756,6.961.056Z",
    transform: "translate(54.596 16.789)",
    fill: "#7b7b7b",
    opacity: 0.37
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.7d51acb47b8eedce261befae60ee7a80.svg";
export { ForwardRef as ReactComponent };